import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

const checkIfDashboardAndrturnValue = (
  dashboardPage: boolean,
  dashboardValue: string,
  value: string
) => (dashboardPage ? dashboardValue : value);

export const usePageHeaderStyles = (
  showBorder: boolean,
  dashboardPage: boolean
) => {
  return {
    pageHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "16px 24px 15px 24px",
      height: "36px",
      width: "100%",
      backgroundColor: colors.gray50,
      borderBottom: showBorder ? `1px solid ${colors.gray200}` : "none",

      // xsm screen:
      "@media(max-width: 599px)": {
        // leave the default pageHeader height in dashboard page
        display: checkIfDashboardAndrturnValue(dashboardPage, "flex", "block"),
        height: checkIfDashboardAndrturnValue(dashboardPage, "36px", "80px"),
        padding: "16px 24px 16px 24px"
      }
    },
    pageHeaderTitle: {
      display: "flex",
      alignItems: "center",

      "@media(max-width: 599px)": {
        // do not add margin to the title on dashboard page
        marginBottom: checkIfDashboardAndrturnValue(
          dashboardPage,
          "unset",
          "8px"
        )
      }
    },
    pageHeaderActions: {
      display: "flex",
      gap: "8px",
      "@media(max-width: 599px)": {
        gap: "16px"
      }
    }
  } as CSSObject;
};
